module.exports = __webpack_public_path__ + "static/media/pizza-pasta.a203ee76.jpg";